import { ApiUtil as api } from "@/utils/api.util.js";

export class TerminologyService {
  static URL = process.env.API_URL + process.env.API_VER;
  static RESOURCE = "/terminologies/";

  static all(queryParams = {}) {
    return api.get(this.URL + this.RESOURCE, queryParams);
  }

  static create(data = {}) {
    return api.post(this.URL + this.RESOURCE, data);
  }

  static update(id, data = {}) {
    return api.put(this.URL + this.RESOURCE + id, data);
  }

  static locale() {
    return api.get(this.URL + this.RESOURCE + "locale");
  }
}



// WEBPACK FOOTER //
// ./src/services/terminology.service.js